import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store';

const selectSelf = (state: RootState) => state;

export const getFailedRecords = createSelector(
  selectSelf,
  ({ authorizePayment }) =>
    authorizePayment.authorizePaymentResult.listOfVendors.filter(
      item => !item.transactionId || item.failReason
    )
);

export const getCompletedRecords = createSelector(
  selectSelf,
  ({ authorizePayment }) =>
    authorizePayment.authorizePaymentResult.listOfVendors.filter(
      item => item.transactionId && !item.failReason
    )
);

export const getPaymentDate = createSelector(
  selectSelf,
  ({ authorizePayment }) => authorizePayment.authorizePaymentResult.paymentDate
);
export const getActiveAuthorizePaymentPage = createSelector(
  selectSelf,
  ({ authorizePayment }) => authorizePayment.activeAuthorizePaymentPage
);
export const getRecordsToRetry = createSelector(
  selectSelf,
  ({ authorizePayment }) => authorizePayment.recordsToRetry
);
